'use strict';

function messagingFactory(sharedConfig, sharedWidgetId) {

    var validTitles = {
            READY: 'READY',
            GET: 'GET',
            OK: 'OK',
            ERROR: 'ERROR',
            NODATA: 'NODATA'
        },
        messageIds = {};

    Object.freeze(validTitles);

    return {
        titles: validTitles,
        generateMessage: generateMessage,
        generateResponseToMessage: generateResponseToMessage,
        isValidTitle: isValidTitle,
        isValidMessage: isValidMessage
    };

    function isValidMessage(message) {
        return (
            typeof (message) === 'object' &&
            message.hasOwnProperty('messageTitle')  && typeof (message.messageTitle) === 'string' &&
            message.hasOwnProperty('widgetId')  && typeof (message.widgetId) === 'string' &&
            message.hasOwnProperty('messageId')  && typeof (message.messageId) === 'string' &&
            message.hasOwnProperty('data') && typeof (message.data) === 'object'
        );
    }

    function isValidTitle(title) {
        try {
            _validTitle(title);
        } catch (e) {
            return false;
        }

        return true;
    }

    function generateMessage(widgetId, title, data) {
        return _generateMessage(widgetId, title, null, data);
    }

    function generateResponseToMessage(widgetId, title, msgId) {
        return _generateMessage(widgetId, title, msgId);
    }

    function _generateMessage(widgetId, title, respondToMessageId, data) {
        var message,
            messageId;

        _validateWidgetId(widgetId);
        _validTitle(title);

        messageId = respondToMessageId || _generateMessageIdForWidget(widgetId);

        message = {
            messageTitle: title,
            widgetId: widgetId,
            messageId: messageId,
            data: typeof (data) === 'object' ? data : {}
        };

        return {
            message: message,
            id: messageId
        };
    }

    function _validTitle(title) {
        var isValid = title in validTitles;

        if (!isValid) {
            throw new Error('iVis shared messaging: unsupported message title: ' + title);
        }
    }

    function _validateWidgetId(widgetId) {
        if (!sharedWidgetId.isValid(widgetId)) {
            throw new Error('iVis shared messaging: unknown widgetId given: ' + widgetId);
        }
    }

    function _generateMessageIdForWidget(widgetId) {
        if (!messageIds[widgetId]) {
            messageIds[widgetId] = 0;
        }

        return sharedConfig.WIDGET_PREFIX + '_' + (++messageIds[widgetId]);
    }

}

// expose based on requesting environment
define('shared/messaging', ['shared/config', 'shared/widgetId'], function (sharedConfig, sharedWidgetId) {
    return messagingFactory(sharedConfig, sharedWidgetId);
});



//////////////////
// WEBPACK FOOTER
// ./src/shared/messaging.js
// module id = 1
// module chunks = 0 1